import React, {Fragment} from "react";
import {getWeeks, weekColSpan} from "./analyticsUtils";

export default function ({reportAnalytics, enablePtoAnalytics}) {
  return (
    <tr>
      <th></th>
      {reportAnalytics.phases.map(phase => (
        <Fragment>
          {
            getWeeks(reportAnalytics.weeks[phase.guid], phase, reportAnalytics, enablePtoAnalytics).map(week => (
              <th data-align="center" key={phase.guid + week.numInPhase} colSpan={weekColSpan(reportAnalytics, phase, week, enablePtoAnalytics)}>{week.header}</th>
            ))
          }
          {!enablePtoAnalytics && <th data-align="center">#</th>}
        </Fragment>
      ))}
      {!enablePtoAnalytics && <th data-align="center">#</th>}
    </tr>
  )
}
